import Link from './link'

Link.install = vue => {
  vue.component(Link.name, Link)
}

export default Link
